// extracted by mini-css-extract-plugin
module.exports = {"txt":"templates_txt__1Lfr_","template":"templates_template__2UtHN","mt":"templates_mt__1fMs2"};